import React from "react";
import Typography from "@material-ui/core/Typography";
import { EmbeddedDoc, EmbeddedDocMobile } from "./FaqPage";

export const InstallRepo = ({ refProp, isMobile }) => {
  return (
    <div ref={refProp}>
      <Typography variant="h3" component="h2">
        <u>Installing the Repo</u>
      </Typography>
      <p>
        We use Swifty to manage our game mods! Its a really easy program to use,
        and keeps the hassle to a minimum. To install Swifty and your mod repo,
        follow the guide below.
      </p>
      {isMobile ? (
        <EmbeddedDocMobile
          text={"How to install: "}
          href={
            "https://docs.google.com/document/d/1VoFXhB1kGKbRAA7EJqzbaCwKVxgeaLNOXjjt6TSgHtE/edit?rm=minimal"
          }
        />
      ) : (
        <EmbeddedDoc>
          <iframe
            title={"HowToInstall"}
            src={
              "https://docs.google.com/document/d/1VoFXhB1kGKbRAA7EJqzbaCwKVxgeaLNOXjjt6TSgHtE/edit?rm=minimal"
            }
          />
        </EmbeddedDoc>
      )}
    </div>
  );
};

export default InstallRepo;
